export default __webpack_public_path__ + "static/media/donecard.cbbcce97.jpg";